 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A00_COVER from '@/components/000_Cover'
 import EBB from '@/components/ebb'
 import PORTALIST from '@/components/portalist'
 import LOVE_1 from '@/components/love_1'
 import A04_TITLE from '@/components/004_Title'
 import A781504086356 from '@/components/9781504086356'
 import A7815040863560 from '@/components/9781504086356-0'
 import A7815040863561 from '@/components/9781504086356-1'
 import A7815040863562 from '@/components/9781504086356-2'
 import A7815040863563 from '@/components/9781504086356-3'
 import A7815040863564 from '@/components/9781504086356-4'
 import A7815040863565 from '@/components/9781504086356-5'
 import A7815040863566 from '@/components/9781504086356-6'
 import A7815040863567 from '@/components/9781504086356-7'
 import A7815040863568 from '@/components/9781504086356-8'
 import A7815040863569 from '@/components/9781504086356-9'
 import A78150408635610 from '@/components/9781504086356-10'
 import A78150408635611 from '@/components/9781504086356-11'
 import A78150408635612 from '@/components/9781504086356-12'
 import A78150408635613 from '@/components/9781504086356-13'
 import A78150408635614 from '@/components/9781504086356-14'
 import A78150408635615 from '@/components/9781504086356-15'
 import A78150408635616 from '@/components/9781504086356-16'
 import A78150408635617 from '@/components/9781504086356-17'
 import A78150408635618 from '@/components/9781504086356-18'
 import A78150408635619 from '@/components/9781504086356-19'
 import A78150408635620 from '@/components/9781504086356-20'
 import A78150408635621 from '@/components/9781504086356-21'
 import A78150408635622 from '@/components/9781504086356-22'
 import A78150408635623 from '@/components/9781504086356-23'
 import A78150408635624 from '@/components/9781504086356-24'
 import A78150408635625 from '@/components/9781504086356-25'
 import A78150408635626 from '@/components/9781504086356-26'
 import A78150408635627 from '@/components/9781504086356-27'
 import A78150408635628 from '@/components/9781504086356-28'
 import A78150408635629 from '@/components/9781504086356-29'
 import A78150408635630 from '@/components/9781504086356-30'
 import A78150408635631 from '@/components/9781504086356-31'
 import A78150408635632 from '@/components/9781504086356-32'
 import A78150408635633 from '@/components/9781504086356-33'
 import A78150408635634 from '@/components/9781504086356-34'
 import A78150408635635 from '@/components/9781504086356-35'
 import A78150408635636 from '@/components/9781504086356-36'
 import A78150408635637 from '@/components/9781504086356-37'
 import A78150408635638 from '@/components/9781504086356-38'
 import A78150408635639 from '@/components/9781504086356-39'
 import A78150408635641 from '@/components/9781504086356-41'
 import A78150408635642 from '@/components/9781504086356-42'
 import A78150408635643 from '@/components/9781504086356-43'
 import A78150408635644 from '@/components/9781504086356-44'
 import A78150408635645 from '@/components/9781504086356-45'
 import A78150408635646 from '@/components/9781504086356-46'
 import A78150408635647 from '@/components/9781504086356-47'
 import A78150408635648 from '@/components/9781504086356-48'
 import A78150408635649 from '@/components/9781504086356-49'
 import A78150408635650 from '@/components/9781504086356-50'
 import A78150408635651 from '@/components/9781504086356-51'
 import A78150408635652 from '@/components/9781504086356-52'
 import A78150408635653 from '@/components/9781504086356-53'
 import A78150408635654 from '@/components/9781504086356-54'
 import A78150408635655 from '@/components/9781504086356-55'
 import A78150408635656 from '@/components/9781504086356-56'
 import LOVE_2 from '@/components/love_2'
 import A78150408635657 from '@/components/9781504086356-57'
 import A78150408635658 from '@/components/9781504086356-58'
 import A70_COPYRIGHT from '@/components/170_Copyright'
 import SERIESBACKAD from '@/components/seriesbackad'
 import A71_ORIMAD from '@/components/171_ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/000_Cover",
 			"name" : "000_Cover",
 			"component" : A00_COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/portalist",
 			"name" : "portalist",
 			"component" : PORTALIST
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/004_Title",
 			"name" : "004_Title",
 			"component" : A04_TITLE
 		},
 		{
 			"path" : "/9781504086356",
 			"name" : "9781504086356",
 			"component" : A781504086356
 		},
 		{
 			"path" : "/9781504086356-0",
 			"name" : "9781504086356-0",
 			"component" : A7815040863560
 		},
 		{
 			"path" : "/9781504086356-1",
 			"name" : "9781504086356-1",
 			"component" : A7815040863561
 		},
 		{
 			"path" : "/9781504086356-2",
 			"name" : "9781504086356-2",
 			"component" : A7815040863562
 		},
 		{
 			"path" : "/9781504086356-3",
 			"name" : "9781504086356-3",
 			"component" : A7815040863563
 		},
 		{
 			"path" : "/9781504086356-4",
 			"name" : "9781504086356-4",
 			"component" : A7815040863564
 		},
 		{
 			"path" : "/9781504086356-5",
 			"name" : "9781504086356-5",
 			"component" : A7815040863565
 		},
 		{
 			"path" : "/9781504086356-6",
 			"name" : "9781504086356-6",
 			"component" : A7815040863566
 		},
 		{
 			"path" : "/9781504086356-7",
 			"name" : "9781504086356-7",
 			"component" : A7815040863567
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js